import React from "react";

// Style \\
import "../../assets/styles/sections/schedule.scss";

// Icons \\
import { LiaPhoneVolumeSolid } from "react-icons/lia";

const Schedule = () => {
  return (
    <section className="schedule">
      <div className="container">
        <div className="schedule_items">
          <div className="schedule_items_formBox">
            <div className="title">
              <h3>Book an Appointment</h3>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque
                placerat scelerisque tortor ornare ornare. Convallis felis vitae
                tortor augue. Velit nascetur proin massa in. Consequat faucibus
                porttitor enim et.
              </p>
            </div>

            <form>
              <div className="first">
                <div className="input ">
                  <input
                    type="text"
                    className="other forBorder"
                    placeholder="Full Name"
                  />
                </div>

                <div className="input ">
                  <select
                    name="gender"
                    className="select"
                    placeholder="gender forBorder1"
                    id="cars"
                  >
                    <option value="volvo" selected>
                      Gender
                    </option>
                    <option value="volvo">Male</option>
                    <option value="saab">Female</option>
                  </select>
                </div>
              </div>

              <div className="first">
                <div className="input ">
                  <input
                    type="Num"
                    className="other phone"
                    placeholder="Phone"
                  />
                </div>

                <div className="input ">
                  <input type="date" className="other date" placeholder="Date" />
                </div>
              </div>

              <div className="first">
                <div className="input ">
                  <input type="time" className="other" placeholder="Time" />
                </div>

                <div className="input ">
                  <select
                    name="cars"
                    className="select doctorsSelect"
                    id="cars"
                  >
                    <option value="volvo" selected>
                      Doctors
                    </option>
                    <option value="volvo">Neurology</option>
                    <option value="saab">Bones</option>
                    <option value="saab">Oncology</option>
                    <option value="saab">Otorhinolaryngology</option>
                    <option value="saab">Ophthalmology</option>
                    <option value="saab">Cardiovascular</option>
                    <option value="saab">Pulmonology</option>
                    <option value="saab">Renal Medicine</option>
                    <option value="saab">Gastroenterology</option>
                    <option value="saab">Urology</option>
                    <option value="saab">Dermatology</option>
                    <option value="saab">Gynaecology</option>
                  </select>
                </div>
              </div>

              <div className="textAreaNew">
                <textarea
                  name="Message"
                  placeholder="What is your complaint"
                  cols="30"
                  rows="11"
                ></textarea>
              </div>

              <div className="button_box">
                <button>Submit</button>
              </div>
            </form>
          </div>

          <div className="timeTable">
            <div className="timeTable_title">
              <h4>Shedule hours</h4>
            </div>

            <div className="weekdays_box">
              <div className="weekdays">
                <div className="day">
                  <p>Monday</p>
                </div>
                <div className="hr"></div>
                <div className="time">
                  <p>09:00 AM - 07:00 PM</p>
                </div>
              </div>

              <div className="weekdays">
                <div className="day">
                  <p>Tuesday</p>
                </div>
                <div className="hr"></div>
                <div className="time">
                  <p>09:00 AM - 07:00 PM</p>
                </div>
              </div>

              <div className="weekdays">
                <div className="day">
                  <p>Wednesday</p>
                </div>
                <div className="hr"></div>
                <div className="time">
                  <p>09:00 AM - 07:00 PM</p>
                </div>
              </div>

              <div className="weekdays">
                <div className="day">
                  <p>Thursday</p>
                </div>
                <div className="hr"></div>
                <div className="time">
                  <p>09:00 AM - 07:00 PM</p>
                </div>
              </div>

              <div className="weekdays">
                <div className="day">
                  <p>Friday</p>
                </div>
                <div className="hr"></div>
                <div className="time">
                  <p>09:00 AM - 07:00 PM</p>
                </div>
              </div>

              <div className="weekdays">
                <div className="day">
                  <p>Saturday</p>
                </div>
                <div className="hr"></div>
                <div className="time">
                  <p>09:00 AM - 07:00 PM</p>
                </div>
              </div>

              <div className="weekdays">
                <div className="day">
                  <p>Sunday</p>
                </div>
                <div className="hr"></div>
                <div className="time">
                  <p>Closed</p>
                </div>
              </div>
            </div>

            <div className="hr"></div>

            <div className="emergency">
              <div className="icon">
                <LiaPhoneVolumeSolid className="icons" />
              </div>

              <div className="text">
                <p>Emergency</p>
                <p className="text">(237) 681-812-255</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Schedule;
